import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';

import type { SalesOrderDetail } from '../types';

const useSalesOrderDetailQuery = (salesOrderId: string) => {
  return useQuery({
    queryKey: ['sales-order-detail', { salesOrderId }],
    queryFn: async ({ signal }) => {
      return API.get(`/sales-orders/so-id/${salesOrderId}`, {
        signal,
      });
    },
    select: (res) => {
      return res?.data as SalesOrderDetail;
    },
    staleTime: 1000 * 20,
    enabled: !!salesOrderId,
  });
};

export default useSalesOrderDetailQuery;
